const apiKey = process.env.NEXT_PUBLIC_GOOGLE_API_KEY;
if (!apiKey) throw new Error(`NEXT_PUBLIC_GOOGLE_API_KEY must be set.`);

export const googleApiSrc = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
